export const commonStyles = theme => ({
    button: {
        backgroundColor: theme.palette.blue,
        color: theme.palette.white,
        textTransform: 'unset',
        height: '48px',
        borderRadius: '6px',
        marginTop: '20px',
        fontSize: '16px'
    },
})

export const snackbarStyles = theme => ({
    success:{
        backgroundColor: theme.palette.turquoise
    },
    info:{
        backgroundColor: theme.palette.blue
    },
    error:{
        backgroundColor: theme.palette.red
    }
})